// REPRINTED のコレクションページ（sections/main-collection-rp-archive.liquid）の動き。
// 番号を選ぶと、写真と、商品ページへのボタンの行き先が変わる。最初の画面は号（箱・名前・値段・限定数も）、その下は Uncut Sheet のシート。
(() => {
  // The store's banner sits above the page; the first screen leaves room for it, as reprinted.cards' does for its own masthead
  const page = document.querySelector('.rpa');
  if (page) {
    const chrome = () => page.style.setProperty('--rpa-chrome', Math.max(0, Math.round(page.getBoundingClientRect().top + window.scrollY)) + 'px');
    chrome();
    window.addEventListener('load', chrome, { once: true });
    window.addEventListener('resize', chrome, { passive: true });
    // The banner changes height when its notice is closed or the header wraps
    if ('ResizeObserver' in window) {
      const watch = new ResizeObserver(chrome);
      document.querySelectorAll('.shopify-section-group-header-group').forEach((el) => watch.observe(el));
    }
  }

  const select = (tabs, tab) => tabs.forEach((t) => {
    const on = t === tab;
    t.setAttribute('aria-selected', on ? 'true' : 'false');
    t.tabIndex = on ? 0 : -1;
  });

  // Arrow keys move between the tabs of one list, as in reprinted.cards' tab lists
  const keys = (tabs, choose) => {
    tabs.forEach((tab, i) => tab.addEventListener('keydown', (event) => {
      const next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[event.key];
      if (next === undefined) return;
      event.preventDefault();
      const target = tabs[(next + tabs.length) % tabs.length];
      target.focus();
      choose(target);
    }));
  };

  // Each picker: a tab shows its picture and points the button at its page; the decks also carry their name, price, stock and print run
  document.querySelectorAll('[data-rpa-picker]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"][data-panel]')];
    const panels = [...root.querySelectorAll('[data-rpa-panel]')];
    const stage = root.querySelector('[role="tabpanel"]');
    const link = root.querySelector('[data-rpa-link]');
    const name = root.querySelector('[data-rpa-name]');
    const price = root.querySelector('[data-rpa-price]');
    const state = root.querySelector('[data-rpa-state]');
    const run = root.querySelector('[data-rpa-run]');
    const choose = (tab) => {
      if (tab.getAttribute('aria-selected') === 'true') return;
      const d = tab.dataset;
      select(tabs, tab);
      panels.forEach((panel) => { panel.hidden = panel.dataset.rpaPanel !== d.panel; });
      if (stage) stage.setAttribute('aria-labelledby', tab.id);
      if (link && d.url) link.href = d.url;
      if (name && d.name) name.textContent = d.name;
      if (price && d.price) price.textContent = d.price;
      if (state && d.available) state.hidden = d.available === 'true';
      if (run && d.run !== undefined) { run.textContent = d.run; run.hidden = !d.run; }
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => choose(tab)));
    keys(tabs, choose);

    // The other pictures are fetched once the reader reaches for the tabs; on the first screen also a moment after the page has loaded,
    // below it once the picker comes near, so a switch shows its picture at once
    const fetchAll = () => panels.forEach((panel) => panel.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; }));
    const list = tabs.length ? tabs[0].parentElement : null;
    if (list) ['pointerenter', 'focusin', 'touchstart'].forEach((type) => list.addEventListener(type, fetchAll, { once: true, passive: true }));
    if (root.closest('.rpa-hero')) {
      window.addEventListener('load', () => setTimeout(fetchAll, 2500), { once: true });
    } else if ('IntersectionObserver' in window) {
      const near = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        near.disconnect();
        fetchAll();
      }, { rootMargin: '400px 0px' });
      near.observe(root);
    }
  });
})();
